import classNames from "classnames";
import style from "./loading.module.css";

function Laoding({ className = "" }) {
  return (
    <div className={classNames(style.loading, className)}>
      <div className={style["lds-ellipsis"]}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Laoding;
